<template>
    <div>
        <vx-card title="Supplier Deposit">
            <vs-tabs :color="colorx" v-model="tabs">
                <vs-tab @click="colorx = 'primary'" label="Apply">
                    <div class="con-tab-ejemplo">
                        <apply/>
                    </div>
                </vs-tab>
                <vs-tab @click="colorx = 'primary'" label="Applied">
                    <div class="con-tab-ejemplo">
                        <reconcile />
                    </div>
                </vs-tab>
                <!-- <vs-tab @click="colorx = 'success'" label="Waiting Reverse">
                    <div class="con-tab-ejemplo">
                        <waiting />
                    </div>
                </vs-tab>
                <vs-tab @click="colorx = 'primary'" label="Reconciled">
                    <div class="con-tab-ejemplo">
                        <reconciled />
                    </div>
                </vs-tab>
                <vs-tab @click="colorx = 'danger'" label="Reversed">
                    <div class="con-tab-ejemplo">
                        <reversed/>
                    </div>
                </vs-tab>
                <vs-tab @click="colorx = 'danger'" label="Cancel">
                    <div class="con-tab-ejemplo">
                        <cancel/>
                    </div>
                </vs-tab> -->
                <vs-tab @click="colorx = 'primary'" label="By Supplier">
                    <div class="con-tab-ejemplo">
                        <supplierDeposit :collectionDate="null" :depositDate="null"/>
                    </div>
                </vs-tab>
            </vs-tabs>
        </vx-card>
    </div>
</template>
<script>
import apply from "./apply/apply.vue";
import reconcile from "./reconcile/reconcile.vue";
import supplierDeposit from "./supplier_deposit/index.vue";
// import done from "./done.vue";

export default {
    components: {
        apply,
        reconcile,
        supplierDeposit
        // done,
    },
    data:() => ({
        colorx: "danger",
        tabs: 0,
    })
}
</script>
